import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import NavBar from './components/Navbar'
import AdminShopUpdate from "./views/admin/AdminShopUpdate.vue";
import axios from './utils/AxiosUtils';
import errorHandler from './utils/ExceptionHandler';
import Notify from 'vue-notifyjs';
import 'vue-notifyjs/themes/default.css';
// eslint-disable-next-line no-unused-vars
import notificationUtils from './utils/NotificationUtils';
import alertUtils from './utils/AlertUtils';
import AdminShopList from "./views/admin/AdminShopList.vue";
import AdminProductList from "./views/admin/AdminProductList.vue";
import AdminCategoryManagement from "./views/admin/AdminCategoryManagement.vue";
import AdminProductTypeList from "./views/admin/AdminProductTypeList.vue";
import AdminPaymentReport from "./views/admin/AdminPaymentReport.vue";
import AdminShopOrdersReport from "./views/admin/AdminShopOrdersReport.vue";
import AdminShopProfitReport from "./views/admin/AdminShopProfitReport.vue";
import AdminWarningManagement from "./views/admin/AdminWarningManagement.vue";
import Order from './views/clients/Order.vue'
import ClientOrderList from './views/clients/ClientOrderList.vue'
import ClientReceiptList from './views/clients/ClientReceiptList.vue'
import TransactionHistory from './views/clients/TransactionHistory.vue'
import AdminTransactionHistory from './views/admin/AdminTransactionHistory.vue'
import Balance from './views/clients/Balance.vue'
import BalanceWithCard from './views/clients/BalanceWithCard.vue'
import Login from "./views/user/Login";
import Page401 from "./views/Page401";
import AdminPanel from "./views/adminPanel/AdminPanel";
import restaurantListImage from "./assets/images/AdminPanelImages/restaurant.png"
import productListImage from "./assets/images/AdminPanelImages/products.png"
import categoryManagementImage from "./assets/images/AdminPanelImages/category.png"
import productTypeManagementImage from "./assets/images/AdminPanelImages/product-type.png"
import paymentReportImage from "./assets/images/AdminPanelImages/payment-report.png"
import shopOrderReportImage from "./assets/images/AdminPanelImages/shopping-cart.png"
import shopProfitReportImage from "./assets/images/AdminPanelImages/shop-profit.png"
import warningImage from "./assets/images/AdminPanelImages/warning.png"
import AdminProductUpdate from "@/views/admin/AdminProductUpdate.vue";
import AdminOrderList from "@/views/admin/AdminOrderList.vue";
import AdminShipmentDocumentList from "@/views/admin/AdminShipmentDocumentList.vue";
import PaymentSuccess from "@/views/payment/PaymentSuccess.vue";
import PaymentFail from "@/views/payment/PaymentFail.vue";


Vue.component('nav-bar', NavBar);
Vue.use(Router);
Vue.use(BootstrapVue);

Vue.use(Notify);
Vue.use(axios);
Vue.use(errorHandler);
Vue.use(notificationUtils);
Vue.use(alertUtils);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login,
            meta: { title: 'Giriş Yap', isPublic: true }
        },
        {
            path: '/order',
            name: 'Order',
            component: Order,
            meta: { title: 'Sipariş Ver', roles: ["ROLE_USER"] }
        },
        {
            path: '/client-order-list',
            name: 'ClientOrderList',
            component: ClientOrderList,
            meta: { title: 'Sipariş Geçmişi', roles: ["ROLE_USER"] }
        },
        {
            path: '/client-receipt-list',
            name: 'ClientReceiptList',
            component: ClientReceiptList,
            meta: { title: 'Dekont Geçmişi', roles: ["ROLE_USER"] }
        },
        {
            path: '/transaction-history-list',
            name: 'TransactionHistory',
            component: TransactionHistory,
            meta: { title: 'Ekstre', roles: ["ROLE_USER"] }
        },
        {
            path: '/balance',
            name: 'Balance',
            component: Balance,
            meta: { title: 'Bakiye Yükle', roles: ["ROLE_USER"] }
        },
        {
            path: '/balance-with-card',
            name: 'BalanceWithCard',
            component: BalanceWithCard,
            meta: { title: 'Kart ile Bakiye Yükle', roles: ["ROLE_USER"] }
        },
        {
            path: '/shop-list',
            name: 'AdminShopList',
            component: AdminShopList,
            meta: { title: 'İşletme Listesi', roles: ["ROLE_ADMIN"], operations: "panelOperations", image: restaurantListImage }
        },
        {
            path: '/product-list',
            name: 'AdminProductList',
            component: AdminProductList,
            meta: { title: 'Ürün Listesi', roles: ["ROLE_ADMIN"], operations: "panelOperations", image: productListImage }
        },
        {
            path: '/category-management',
            name: 'AdminCategoryManagement',
            component: AdminCategoryManagement,
            meta: { title: 'Kategori Yönetimi', roles: ["ROLE_ADMIN"], operations: "panelOperations", image: categoryManagementImage }
        },
        {
            path: '/product-type-management',
            name: 'AdminProductTypeList',
            component: AdminProductTypeList,
            meta: { title: 'Ürün Tipi Yönetimi', roles: ["ROLE_ADMIN"], operations: "panelOperations", image: productTypeManagementImage }
        },
        {
            path: '/payment-report',
            name: 'AdminPaymentReport',
            component: AdminPaymentReport,
            meta: { title: 'Ödeme Listesi', roles: ["ROLE_ADMIN"], operations: "reportOperations", image: paymentReportImage }
        },
        {
            path: '/shop-orders-report',
            name: 'AdminShopOrdersReport',
            component: AdminShopOrdersReport,
            meta: { title: 'İşletme Sipariş Listesi', roles: ["ROLE_ADMIN"], operations: "reportOperations", image: shopOrderReportImage }
        },
        {
            path: '/shop-profit-report',
            name: 'AdminShopProfitReport',
            component: AdminShopProfitReport,
            meta: { title: 'İşletme Kâr Raporu', roles: ["ROLE_ADMIN"], operations: "reportOperations", image: shopProfitReportImage }
        },
        {
            path: '/warnings',
            name: 'AdminWarningManagement',
            component: AdminWarningManagement,
            meta: { title: 'Uyarılar', roles: ["ROLE_ADMIN"], operations: "warningOperations", image: warningImage }
        },
        {
            path: '/transaction-histories/:id/:name',
            name: 'AdminTransactionHistory',
            component: AdminTransactionHistory,
            meta: { title: 'Ekstre', roles: ["ROLE_ADMIN"] }
        },
        {
            path: '/adminPanel',
            name: 'AdminPanel',
            component: AdminPanel,
            meta: { title: 'Admin Paneli', roles: ["ROLE_ADMIN"] }
        },
        {
            path: '/update-shop',
            name: 'AdminShopUpdate',
            component: AdminShopUpdate,
            meta: { title: 'Güncelle', roles: ["ROLE_ADMIN"]  }
        },
        {
            path: '/update-product',
            name: 'AdminProductUpdate',
            component: AdminProductUpdate,
            meta: { title: 'Güncelle', roles: ["ROLE_ADMIN"]  }
        },
        {
            path: '/admin-order-list',
            name: 'AdminOrderList',
            component: AdminOrderList,
            meta: { title: 'Siparişler', roles: ["ROLE_ADMIN"] }
        },
        {
            path: '/shipment-documents',
            name: 'AdminShipmentDocumentList',
            component: AdminShipmentDocumentList,
            meta: { title: 'İrsaliyeler', roles: ["ROLE_ADMIN"] }
        },
        {
            path: '/payment/success',
            name: 'PaymentSuccess',
            component: PaymentSuccess,
            meta: { title: 'Ödeme Başarılı', isPublic: true }
        },
        {
            path: '/payment/fail',
            name: 'PaymentFail',
            component: PaymentFail,
            meta: { title: 'Ödeme Başarısız', isPublic: true }
        },
        {
          path: '/401',
          name: '401',
          component: Page401,
          meta: {title: 'Yetkisiz Erişim', isPublic: true }
        }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    const isPublic = to.matched.some(record => record.meta.isPublic);
    const roles = to.meta.roles;
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))  : null;
    const userRole = user ? user.role : null;

    if(isPublic){
        next();
    }
    else if (!userRole) {
        return next({
            path:'/',
            query: {redirect: to.fullPath}
        });
    }

    else if(roles && !roles.includes(userRole)){
        return next({
            path:'/401',
            query: {redirect: to.fullPath}
        });
    }
    else {
        next();
    }
});

export default router;
